/** @jsxImportSource theme-ui */
import { Container, Heading } from 'theme-ui';
import EditTicket from '@/containers/tickets/EditTicket';

const EditTicketPage = () => {
    return (
        <Container>
            <Heading sx={{ textTransform: 'capitalize' }} as="h2">
                Edit Ticket
            </Heading>
            <EditTicket />
        </Container>
    );
};

export default EditTicketPage;
